
import { useEffect } from 'react'

const useOnSearchElementsConfig = (searchManager, listBoardElementsData, setSearchManager, setListBoardElementsAux, setListBoardElementsGridAux) => {    
    useEffect(()=> {
        const getData = async () => {
            setSearchManager && setSearchManager(prevState => ({
                ...prevState,
                fireSearch: false,
            }));

            const data = listBoardElementsData.filter(x =>
                 x.code.toLowerCase().indexOf(searchManager.text.toLowerCase()) !== -1 ||
                 x.name.toLowerCase().indexOf(searchManager.text.toLowerCase()) !== -1
            )
            setListBoardElementsAux && setListBoardElementsAux(data);
            setListBoardElementsGridAux && setListBoardElementsGridAux(prevState => ({
                ...prevState,
                data: data,
                fireUpdate: true,
            }));
        }
        
        if (listBoardElementsData !== null && searchManager.fireSearch === true && searchManager.text !== "") {
            getData()
        }
    }, [searchManager, listBoardElementsData, setSearchManager, setListBoardElementsAux, setListBoardElementsGridAux]);
}

export {
    useOnSearchElementsConfig,
}

